import { render } from "./ManageChapter.vue?vue&type=template&id=85c7daac&scoped=true"
import script from "./ManageChapter.vue?vue&type=script&lang=js"
export * from "./ManageChapter.vue?vue&type=script&lang=js"

import "./ManageChapter.vue?vue&type=style&index=0&id=85c7daac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c7daac"]])

export default __exports__